/**
 * The languages sign-in ships, and which one a browser gets.
 *
 * ADDING A LANGUAGE: add `public/i18n/<id>.json` (written by the translation
 * portal, never by hand), an entry in AVAILABLE_LANGS and its BCP-47 tag in
 * MESSAGEFORMAT_LOCALES. A language missing from either list silently falls
 * back to English.
 */
export const AVAILABLE_LANGS = [{ id: 'en', label: 'English' }];

/** English is the source catalogue and the fallback. */
export const DEFAULT_LANG = 'en';

/** Plural rules are per locale: every shipped language needs its tag here. */
export const MESSAGEFORMAT_LOCALES = ['en-GB'];

/**
 * The first browser language we ship, matched on its primary subtag
 * (`ja-JP` → `ja`); English when none is shipped.
 */
export function resolveBrowserLang(languages: readonly string[]): string {
  const shipped = new Set(AVAILABLE_LANGS.map((lang) => lang.id));
  for (const tag of languages) {
    const primary = tag?.trim().split(/[-_]/)[0]?.toLowerCase();
    if (primary && shipped.has(primary)) return primary;
  }
  return DEFAULT_LANG;
}
